export default __webpack_public_path__ + "static/philrx-access-solution-39417770b6b76309532a5666010d8851.jpg";